export default "__VITE_ASSET__by2S2l1b__"